<template>
    <div>
        <div v-if="multiple">
            <div v-for="(file, index) in value" :key="index">
                <a target="_blank" class="fh-download-file btn btn-primary" v-if="oldValue && oldValue[index]" :href="oldValue[index]">DOWNLOAD</a>
                <input v-if="! file.name" type="file" :disabled="disabled" :class="aspect.formFieldClass" @change="processFile($event, index)" :accept="accept.join(',')">
                <div v-else>
                    <span>{{file.name}}</span>
                    <button @click="remove($event, index)" style="float:right;">{{translations.remove}}</button>
                    <div style="clear: both; margin-bottom: 5px;"></div>
                </div>
            </div>
            <button class="btn btn-primary btn-sm" @click="add" v-if="!disabled">{{translations.add}}</button>
        </div>
        <div v-else>
            <div class="input-group">
                <div class="input-group-prepend" v-if="oldValue">
                    <span class="input-group-text" :id="name"><a target="_blank" :href="oldValue"><i class="fa fa-download"></i></a></span>
                </div>
                <input :id="name" type="file" :class="aspect.formFieldClass+' custom-file-input'" :disabled="disabled" @change="processSingleFile($event)" :accept="accept.join(',')" :aria-describedby="name">
                <label class="custom-file-label" :for="name">{{(typeof value === 'object' && value !== null)?value.name:''}}</label>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            name: null,
            value:null,
            placeholder: null,
            oldValue: null,
            multiple: {type: Boolean, default: false},
            validations: {type: Array, default: function(){ return []; }},
            translations: {type: Object, default: function(){ return {}; }},
            aspect: {type: Object, default: function(){ return {}; }},
            disabled: {type: Boolean, default: false}
        },
        data() {
            return {
                accept: [],
                maxsize: null
            }
        },
        mounted(){
            if(this.validations && this.validations.length > 0){
                for(var i=0; i<this.validations.length; i++){
                    if(this.validations[i].type == "accept"){
                        this.accept = this.validations[i].value;
                    }
                    if(this.validations[i].type == "maxsize"){
                        this.maxsize = this.validations[i].value;
                    }
                }
            }
            if(!this.value){
                if(this.multiple){
                    this.$emit('input', [{}]);
                }else{
                    this.$emit('input', null);
                }
            }
        },
        methods: {
            add(e) {
                e.preventDefault();
                var files = this.value.slice(0);
                files.push({});
                this.$emit('input', files);
            },
            remove(event, index){
                event.preventDefault();
                var files = [];
                for(var i=0; i<this.value.length; i++){
                    if(i != index){
                        files.push(this.value[i])
                    }
                }
                this.$emit('input', files)
            },
            processFile(event, index){
                var files = this.value.slice(0);
                files[index] = event.target.files[0]
                this.$emit('input', files)
            },
            processSingleFile(event){
                this.$emit('input', event.target.files[0])
            }
        }

    }
</script>
